export const createArrayOfOptions = ({ start = 1, end, step = 1, formatted = false, }) => Array.from({ length: Math.ceil((end - start) / step) + 1 }, (_, i) => {
    const number = start + i * step;
    return {
        label: `${formatted ? number.toFixed(2) : number}`,
        value: `${number}`,
    };
});
